import { z } from 'zod';

// Schema for WebSocket TOKEN_TRANSFER messages
// Only validates fields used by the handler - see TransferDto for full type
export const TokenTransferSchema = z.object({
  data: z.array(
    z
      .object({
        subaccountId: z.string().uuid(),
        type: z.enum(['DEPOSIT', 'WITHDRAW', 'FEES_CLAIMED']),
      })
      .passthrough()
  ),
});

export type WsTokenTransfers = z.infer<typeof TokenTransferSchema>;
export type WsTokenTransfer = WsTokenTransfers['data'][number];
